/** Opens and closes the main menu, which is a drawer on small screens. */
const toggle = document.querySelector('.header__toggle');

if (toggle) {
  const menu = document.getElementById(toggle.getAttribute('aria-controls'));
  const isOpen = () => toggle.getAttribute('aria-expanded') === 'true';
  const setOpen = (open) => {
    toggle.setAttribute('aria-expanded', String(open));
    // Keeps the page behind the drawer from scrolling.
    document.documentElement.classList.toggle('menu-open', open);
    if (open) {
      menu.querySelector('a')?.focus();
    }
  };

  toggle.addEventListener('click', () => setOpen(!isOpen()));

  document.querySelectorAll('[data-menu-close]').forEach((element) => {
    element.addEventListener('click', () => {
      setOpen(false);
      toggle.focus();
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && isOpen()) {
      setOpen(false);
      toggle.focus();
    }
  });

  // Back on a wide screen the drawer no longer exists; make sure nothing stays locked.
  window.matchMedia('(min-width: 750px)').addEventListener('change', (event) => {
    if (event.matches && isOpen()) setOpen(false);
  });
}
